import { useContext, useMemo } from 'react';
import { useMutation } from '@tanstack/react-query';
import { ChatStateDispatchContext } from '@trinity/chat-components/components/Chat.State/context';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import { ActiveChatSessionContext, SubmitMessageContext } from '../context';

export function useCancelQueryMutation() {
  const apiClient = useChatApiClient();

  const chat = useContext(ActiveChatSessionContext);
  const dispatch = useContext(ChatStateDispatchContext);

  const { state } = useContext(SubmitMessageContext);

  const queryIdentifier = useMemo(() => {
    if (state.status !== 'submitting-query') {
      return null;
    }
    return state.queryIdentifier;
  }, [state]);

  const chatId = useMemo(() => {
    if (typeof chat.id !== 'number' || Number.isNaN(chat.id)) {
      return null;
    }
    return chat.id;
  }, [chat.id]);

  return useMutation({
    mutationFn: async () => {
      if (!queryIdentifier || chatId === null) {
        return {
          didCancel: false,
        };
      }
      await apiClient.queries.cancelQuery({
        chatId,
        queryIdentifier,
      });
      return {
        didCancel: true,
      };
    },
    onSuccess: (result) => {
      if (!queryIdentifier || !result.didCancel) {
        return;
      }
      dispatch({
        type: 'query-cancelled',
        payload: { queryIdentifier },
      });
    },
  });
}
